/**
 * Tryb ciemny sekcji egzaminów — wspólne stałe dla serwera (layout czyta ciasteczko) i klienta
 * (przełącznik je zapisuje).
 *
 * Ciasteczko, nie localStorage: layout grupy (application) renderuje klasę `dark` po stronie serwera,
 * więc ciemny ekran przychodzi już w pierwszym HTML-u. localStorage jest widoczny dopiero po hydracji,
 * czyli user dostałby błysk bieli przy każdym wejściu — dokładnie to, co ma naprawić ten tryb.
 *
 * Motyw celowo NIE jest zapisywany na koncie: telefon w łóżku i desktop w pracy chcą różnych ustawień,
 * a zapis per urządzenie nie wymaga niczego po stronie backendu.
 */
export const EXAM_THEME_COOKIE = "remedium-exam-theme";

/** Kanały mają ten sam mechanizm motywu, ale osobny wybór. */
export const CHANNELS_THEME_COOKIE = "remedium-channels-theme";

const EXAM_THEME_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export const buildExamThemeCookie = (
  isDark: boolean,
  cookieName: string = EXAM_THEME_COOKIE,
): string =>
  `${cookieName}=${
    isDark ? "dark" : "light"
  }; path=/; max-age=${EXAM_THEME_MAX_AGE_SECONDS}; samesite=lax`;
